import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "text"
}
const _hoisted_3 = ["src", "alt"]

import vue from '../../../../adapter-vue';
import {
  CUSTOM_BASIC_EMOJI_URL,
  CUSTOM_BASIC_EMOJI_URL_MAPPING,
} from '../../emoji-config';
import { isPC } from '../../../../utils/env';
import { getStyledATagFromText } from '../../../../utils/utils';
import state from '../../../../utils/state.js';
interface IProps {
  content: Record<string, any>;
  flow: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'message-text',
  props: {
    content: { default: () => ({}) },
    flow: { default: 'in' }
  },
  setup(__props: any) {

const {ref, computed } = vue;
const props = __props;
const enableURLDetection = ref(state.get('enableURLDetection'));
const linkColor = computed(() => {
  return props.flow === 'out' ? '#fff' : '#0052d9';
});
const textMessageData = computed(() => {
  const contentCopy = JSON.parse(JSON.stringify(props.content));
  contentCopy.text?.forEach(
    (item: {
      name: string;
      text?: string;
      src?: string;
      type?: string;
      emojiKey?: string;
    }) => {
      if (item.name === 'img' && item?.type === 'custom') {
        if (!CUSTOM_BASIC_EMOJI_URL) {
          console.warn('CUSTOM_BASIC_EMOJI_URL is required for custom emoji, please check your CUSTOM_BASIC_EMOJI_URL.');
        } else if (!item.emojiKey || !CUSTOM_BASIC_EMOJI_URL_MAPPING[item.emojiKey]) {
          console.warn('emojiKey is required for custom emoji, please check your emojiKey.');
        } else {
          item.src
            = CUSTOM_BASIC_EMOJI_URL
            + CUSTOM_BASIC_EMOJI_URL_MAPPING[item.emojiKey];
        }
      } else if (item.name === 'text' && enableURLDetection.value) {
        item.text = getStyledATagFromText(item.text || '', "message-text-link", linkColor.value, '');
      }
    },
  );
  return contentCopy;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['message-text-container', _unref(isPC) && 'text-select'])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(textMessageData).text, (item, index) => {
      return (_openBlock(), _createElementBlock("span", { key: index }, [
        (item.name === 'text' && _unref(enableURLDetection) === 1)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "text",
              innerHTML: item.text
            }, null, 8, _hoisted_1))
          : (item.name === 'text')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.text), 1))
            : (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: "emoji",
                src: item.src,
                alt: item.emojiKey
              }, null, 8, _hoisted_3))
      ]))
    }), 128))
  ], 2))
}
}

})